import Globals from '@/config/Globals';
//
export default class APIUnitsNumber {
  constructor(API) {
    this.api = API;
  }

  async getAll() {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_UnitsNumber;
    return await req.exec();
  }

  async create(unitNumberObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = Globals.APIPath_UnitNumber + Globals.URL_NewIndentifier;
    req.body = { ...unitNumberObj };
    return await req.exec();
  }

  async update(unitNumberObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = Globals.APIPath_UnitNumber + unitNumberObj.id;
    delete unitNumberObj.id;
    req.body = { ...unitNumberObj };
    return await req.exec();
  }

  async remove(unitNumberID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = Globals.APIPath_UnitNumber + unitNumberID;
    return await req.exec();
  }
}
